export default __webpack_public_path__ + "static/media/photo11.5fa6a8cc.jpg";